import Entity from '@/plugins/podolib/services/entities/Entity';

export type TStation = {
  serial: string;
  mac: string;
  name: string;
  activated: true;
  online: false;
  version: string;
};

/**
 * @author Damien CORLER <d.corler@zhortech.com>
 * @since 1.0.0
 * @version 1.0.0
 */
export default class EntityStations extends Entity<TStation> {
  name: string = 'stations';
}
